import type { ReactElement, ReactNode } from 'react'
import { Group } from '@mantine/core'
import { TButton } from '@components'

type ScopeOptionButtonProps = {
  children: ReactNode
  onClick: () => void
}

export const DashboardScopeOptionButton = ({ children, onClick }: ScopeOptionButtonProps): ReactElement => {
  return (
    <TButton color='neutral' justify='flex-start' onClick={onClick} variant='ghost'>
      <Group justify='space-between' w='100%'>
        {children}
      </Group>
    </TButton>
  )
}
